import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable, ReplaySubject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {ReceivablesTransfer} from "../interface/receivables-transfer";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesTransferService {

  private readonly receivablesTransferListSubject: ReplaySubject<CountedAndPaginated<ReceivablesTransfer>> =
    new ReplaySubject<CountedAndPaginated<ReceivablesTransfer>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,  ) { }


  public getReceivablesTransferListSubject(): ReplaySubject<CountedAndPaginated<ReceivablesTransfer>> {
    return this.receivablesTransferListSubject;
  }

  sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/receivables-transfer`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/receivables-transfer/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;

    }
  }

  public get(uuid: string): Observable<ReceivablesTransfer> {
    return this.httpClient.get(`/rest/crm/receivables-transfer/${uuid}`)
      .pipe(first()) as Observable<ReceivablesTransfer>;
  }

  public loadList(filters: object , page: number, pageSize: number,  sort?: { sortBy?: string; sortOrder?: string}): void {
    this.httpClient.get(`/rest/crm/receivables-transfer?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ReceivablesTransfer>) => {
        this.receivablesTransferListSubject.next(result);
      });
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/receivables-transfer/${uuid}`)
      .pipe(first());
  }

  updateStatus(uuid: string, status: number, note?: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-transfer/${uuid}/statusChange`,
      {
        status: status,
        note: note
      })
      .pipe(take(1));
  }
  downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-transfer/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

}
